export default __webpack_public_path__ + "static/media/2.bdfe6e77.jpg";